import { RefObject, useEffect } from "react";

type UseFocusSearchInputProps = {
  isDisabled: boolean;
  typeaheadRef: RefObject<HTMLDivElement>;
};

const useFocusSearchInput = ({
  isDisabled,
  typeaheadRef,
}: UseFocusSearchInputProps) => {
  useEffect(() => {
    if (!isDisabled) {
      const input =
        typeaheadRef.current?.querySelector<HTMLInputElement>("input");
      if (input && !input.disabled) {
        input.focus();
      }
    }
  }, [isDisabled, typeaheadRef]);
};

export default useFocusSearchInput;
